import { useQuery } from '@tanstack/react-query';
import { getLanguages } from 'api/languages';
import { languagesKeys } from 'api/queryKeys';

/** Długi cache – lista języków zmienia się rzadko (ustawiana raz). */
const LANGUAGES_STALE_MS = 7 * 24 * 60 * 60 * 1000; // 7 dni

export const useLanguagesQuery = () =>
  useQuery({
    queryKey: languagesKeys.list(),
    queryFn: () => getLanguages().then((res) => res.data ?? []),
    staleTime: LANGUAGES_STALE_MS,
    gcTime: LANGUAGES_STALE_MS
  });
